module.exports = __webpack_public_path__ + "static/img/xianshi@2x.f009101.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/canvasShow/static/images/shop/xianshi@2x.png
// module id = 9n7a
// module chunks = 18